wbApp.controller('RentCategoryGroupDetailCtrl', ['$scope', '$modal', 'rentCategoryGroupSvc',
function ($scope, $modal, rentCategoryGroupSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {
            rentCategoryGroupSvc.insert(data)
                .$promise.then(success, error);
        } else {
            rentCategoryGroupSvc.update(data)
                .$promise.then(success, error);
        }

        function success(newModel) {
            $scope.onRentCategoryGroupSave(newModel);
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };


    $scope.isFormValid = function() {
        return true;
    }

    $scope.onDeletePictureBtnClick = function (pictureUrl) {
        _.pull($scope.model.pictureUrls || [], pictureUrl);
    }

    $scope.showPictureSelect = function () {
        picturesSelectDlgPromise.$promise.then(function () {
            picturesSelectDlgPromise.$scope.onPicturesSelected = function (pictures) {

                if (!$scope.model.pictureUrls) {
                    $scope.model.pictureUrls = [];
                }

                angular.forEach(pictures, function (p) {
                    if (!_.find($scope.model.pictureUrls, p.imageUrl)) {
                        $scope.model.pictureUrls.push(p.imageUrl);
                    }
                });
            };
            picturesSelectDlgPromise.show();
        });
    }

    var picturesSelectDlgPromise = $modal({
        templateUrl: 'storage/pictures/pictures-select-dlg.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "rents/rent-category-group/rent-category-group-detail-main-tab.html"
    },
    {
        title: 'TXT_LBL_DESCRIPTION',
        template: "rents/rent-category-group/rent-category-group-detail-description-tab.html"
    },
    {
        title: 'TXT_LBL_PICTURES',
        template: "rents/rent-category-group/rent-category-group-detail-pictures-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;
}]);
